import React, { PropsWithChildren } from 'react';

export const ContentWrapper = (props: PropsWithChildren<any>) => {
  return (
    <div className="app-page-content">
      <div className="app-page-content-layout"> {/*Add classes and props later for layout changes such as full width*/}
        {props.children}
      </div>
    </div>
  );
};